import { ContentRecommendation } from '@/components/content/ContentRecommendation';

const EMS_NAME_BENEFITS_GRAY = 'DPSV2_BenefitsGray';
const NullElement = () => null;

export const BenefitsGrayContentRecommendation = () => (
	<ContentRecommendation
		id={EMS_NAME_BENEFITS_GRAY}
		properties={{
			emsName: EMS_NAME_BENEFITS_GRAY,
		}}
		withoutFrame
		loadingElement={<NullElement />}
	/>
);
